import { CollectionRendererComponent } from "@shared/components/table/renderers/collection-renderer/collection-renderer.component";
import { ColumnMetadata } from "@valg-shared/components/table/table/column-metadata";
import { WithPropsOfType } from "@valg-shared/forms";
import { ListCoalitionResultDto } from "@shared/clients/api.generated";

export const CoalitionListColumnDef: WithPropsOfType<ListCoalitionResultDto, ColumnMetadata> = {
  listCoalitionLetter: {
    title: 'coalition_list.column.name'
  },
  candidateLettersList: {
    title: 'coalition_list.column.participants',
    presentationComponent: CollectionRendererComponent
  },
  id: { title: 'id', disable: true },
};
